import React from 'react';
import { format } from 'date-fns';
import { Eye, Pencil, Trash2, ClipboardList } from 'lucide-react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableHeader,
  TableRow,
  Button,
  Badge,
} from '../ui';
import type { SurveyQuestionnaire } from '../../types/survey';

interface QuestionnaireListProps {
  questionnaires: SurveyQuestionnaire[];
  onEdit: (q: SurveyQuestionnaire) => void;
  onDelete: (q: SurveyQuestionnaire) => void;
  onManage: (q: SurveyQuestionnaire) => void;
  onResponses: (q: SurveyQuestionnaire) => void;
}

export const QuestionnaireList: React.FC<QuestionnaireListProps> = ({
  questionnaires,
  onEdit,
  onDelete,
  onManage,
  onResponses,
}) => {
  return (
    <div>
      <div className="mb-4 text-sm text-gray-600 dark:text-gray-400">
        Total de registros: {questionnaires.length}
      </div>
      <TableContainer>
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>ID</TableHead>
              <TableHead>Título</TableHead>
              <TableHead>Descrição</TableHead>
              <TableHead>Perguntas</TableHead>
              <TableHead>Criado em</TableHead>
              <TableHead className="text-right">Ações</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {questionnaires.map((q) => (
              <TableRow key={q.id}>
                <TableCell>
                  <span className="font-medium text-gray-900 dark:text-gray-100">{q.id}</span>
                </TableCell>
                <TableCell>
                  <span className="font-medium text-gray-900 dark:text-gray-100">{q.title}</span>
                </TableCell>
                <TableCell>
                  <span className="text-gray-600 dark:text-gray-400 text-sm truncate max-w-xs block">
                    {q.description || '-'}
                  </span>
                </TableCell>
                <TableCell>
                  <Badge variant="default">{q.question_count}</Badge>
                </TableCell>
                <TableCell>
                  <div className="text-sm">
                    <div className="text-gray-900 dark:text-gray-100">
                      {format(new Date(q.created_at), 'dd/MM/yyyy')}
                    </div>
                    <div className="text-gray-500">
                      {format(new Date(q.created_at), 'HH:mm')}
                    </div>
                  </div>
                </TableCell>
                <TableCell>
                  <div className="flex justify-end gap-2">
                    <Button size="sm" variant="secondary" onClick={() => onManage(q)} title="Gerenciar perguntas">
                      <ClipboardList className="h-4 w-4" />
                    </Button>
                    <Button size="sm" variant="secondary" onClick={() => onResponses(q)} title="Ver respostas">
                      <Eye className="h-4 w-4" />
                    </Button>
                    <Button size="sm" variant="secondary" onClick={() => onEdit(q)} title="Editar">
                      <Pencil className="h-4 w-4" />
                    </Button>
                    <Button size="sm" variant="danger" onClick={() => onDelete(q)} title="Excluir">
                      <Trash2 className="h-4 w-4" />
                    </Button>
                  </div>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
};
